import { render, staticRenderFns } from "./MaterialStatsCard.html?vue&type=template&id=06beaa71&scoped=true&"
import script from "./MaterialStatsCard.ts?vue&type=script&lang=ts&"
export * from "./MaterialStatsCard.ts?vue&type=script&lang=ts&"
import style0 from "./MaterialStatsCard.sass?vue&type=style&index=0&id=06beaa71&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06beaa71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VDivider,VIcon})
